import { createLogger } from "@/shared/logging";
import { readRecord, readString } from "@/shared/http";
import { API_TIMEOUT_MS } from "@/shared/http/resilience";
import { PollingController, type PollingSnapshot } from "@/shared/polling/PollingController";

const logger = createLogger("app/appUpdate");
export const appUpdatePollIntervalMs = 5 * 60_000;

/** API가 아닌 현재 FE origin의 정적 산출물을 캐시 없이 읽는다. */
export async function fetchDeployedBuildId(signal: AbortSignal): Promise<string> {
  const response = await fetch("/build-info.json", {
    cache: "no-store",
    signal: AbortSignal.any([signal, AbortSignal.timeout(API_TIMEOUT_MS)]),
  });
  if (!response.ok) throw new Error(`build-info responded ${response.status}`);
  const body = readRecord(await response.json(), "build-info", "body");
  return readString(body.build_id, "build-info", "build_id");
}

// 실패 후에도 마지막 식별자를 유지해 이미 표시한 안내가 사라지지 않는다.
export const appUpdateController = new PollingController<string>({
  load: fetchDeployedBuildId,
  intervalMs: appUpdatePollIntervalMs,
  onLoadError: (error) => logger.warn("Failed to read deployed build id.", error),
});

// 롤백으로 현재 번들이 다시 배포되면 안내도 사라진다.
export function isBundleStale(snapshot: PollingSnapshot<string>, currentBuildId: string): boolean {
  return snapshot.data !== null && snapshot.data !== currentBuildId;
}
